module.exports = __webpack_public_path__ + "img/420vsIIAF.f31ed7b0.png";